import { HttpParams } from '@angular/common/http';
import {
    MetalTypeModel,
    MetalTypeServer,
    PercentageServerModel,
} from '@domain/entities/setting.type';

import { Observable } from 'rxjs';

export abstract class SettingsGateway {
    abstract readMetal(params?: HttpParams): Observable<MetalTypeServer[]>;
    abstract readPercentage(
        params?: HttpParams
    ): Observable<PercentageServerModel>;
    abstract update(form: MetalTypeModel): Observable<{ msg: string }>;
}
